module.exports = __webpack_public_path__ + "static/img/dkwps2-6.53885af.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-6.png
// module id = 671
// module chunks = 0